var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
// @ts-ignore
import * as React from "react";
import { connect } from "react-redux";
import { IdStyles } from "../../less/IdStyles";
import { selectHappinessInfo } from "../../selectors/selectHappinessInfo";
import { getProductionCostBuffAsPercentage } from "../../selectors/selectRecipeInfo";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { TradeTransitionArrow as Arrow } from "../generic/common/TradeTransitionArrow";
import { TextLoca } from "../generic/text/TextLoca";
import { Happiness } from "./Happiness";
import { ProductionCost } from "./ProductionCost";
var _HudHappinessTooltip = function (_a) {
    var happinessInfo = _a.happinessInfo, productionCost = _a.productionCost;
    return (React.createElement("div", { className: "HudHappinessTooltip" },
        React.createElement("header", { className: "HudHappinessTooltip__header" },
            React.createElement(TextLoca, { className: IdStyles.TextBoldPrimary, id: IdLoca.help_happiness_title }),
            React.createElement(TextLoca, { className: IdStyles.TextSmall, id: IdLoca.help_happiness_desc1 })),
        React.createElement("div", { className: "HudHappinessTooltip__data" },
            React.createElement("div", { className: "HudHappinessTooltip__data-entry" },
                React.createElement(Happiness, __assign({}, happinessInfo))),
            React.createElement("div", { className: "HudHappinessTooltip__arrow" },
                React.createElement(Arrow, null)),
            React.createElement("div", { className: "HudHappinessTooltip__data-entry" },
                React.createElement(ProductionCost, { productionCost: productionCost })))));
};
var mapState = function (state) {
    var happinessInfo = selectHappinessInfo(state);
    var happiness = happinessInfo.happiness + (happinessInfo.happinessBuff || 0);
    var productionCost = getProductionCostBuffAsPercentage(happiness);
    return {
        happinessInfo: happinessInfo,
        productionCost: productionCost,
    };
};
export var HudHappinessTooltip = connect(mapState)(_HudHappinessTooltip);



//////////////////
// WEBPACK FOOTER
// ./src/features/happiness/HudHappinessTooltip.tsx
// module id = 2305
// module chunks = 3